import Add from '@mui/icons-material/Add';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import Loading from '../Loading/Loader';

import {
  fetchAreaOrganizacionalActualizar,
  fetchAreaOrganizacionalAgregar,
  selectAllAreasOrganizacionales,
  selectIsLoading,
} from '../../../redux/AreaOrganizacional/AreaOrganizacionalSlice';

import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { selectAllCargos } from '../../../redux/Cargos/CargosSlice';

const style = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  },
  text: {
    fontSize: 13,
    fontWeight: 'bold',
  },
};

const AreaOrganizacionalNuevo = ({ open: { open, area }, setOpen, openDefaultValue = {} }) => {
  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-FORM
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    control,
  } = useFormContext();

  // ? HOOK-SELECTOR
  const areasOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const isLoading = useSelector(selectIsLoading);
  const cargos = useSelector(selectAllCargos);

  const onSubmit = ({ area: areaUpdate }) => {
    if (area) {
      dispatch(fetchAreaOrganizacionalActualizar(areaUpdate));
      return;
    }

    dispatch(fetchAreaOrganizacionalAgregar(areaUpdate));
  };

  const handleClose = () => {
    setOpen(openDefaultValue);
  };

  useEffect(() => {
    if (area) {
      setValue('area', area);
      setValue('area.nombre', area?.nombre?.replaceAll('-', '') || '');
    }
  }, [area, setValue]);

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
      <Box sx={{ ...style.modal, width: 700 }}>
        {!isLoading ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="container">
              <div className="row">
                <h3 className="text-primary-mem text-center">{area ? 'Editar' : 'Crear'} Área Organizacional</h3>
              </div>
              <div className="row">
                <div className="col-5 me-0 pe-0">
                  <hr />
                </div>
                <div className="col-2 text-center">
                  <Add className="text-primary-mem" />
                </div>
                <div className="col-5 ms-0 ps-0 ">
                  <hr />
                </div>
              </div>
              <div className="row">
                <div className="form-group">
                  <Typography sx={style.text}>Nombre</Typography>
                  <input type="text" {...register('area.nombre', { required: 'El campo es requerido' })} className="form-control" />
                  <p className="text-danger">{errors?.area?.nombre?.message}</p>
                </div>

                <div className="form-group">
                  <Typography sx={style.text}>Área Padre</Typography>
                  <Controller
                    control={control}
                    className="mb-3"
                    name="area.padre"
                    rules={{
                      required: 'El campo es requerido',
                    }}
                    render={({ field }) => (
                      <Select
                        classNamePrefix="select"
                        isSearchable={true}
                        placeholder="Seleccionar Área Padre"
                        options={areasOrganizacionales}
                        getOptionLabel={(option) => option.nombre}
                        getOptionValue={(option) => option.id}
                        onChange={(e) => field.onChange(e.id)}
                        value={areasOrganizacionales.find((x) => x.id === field.value)}
                      />
                    )}
                  />

                  <p className="text-danger mb-0">{errors?.area?.padre?.message}</p>
                </div>

                <div className="form-group mt-3">
                  <Typography sx={style.text}>Área Máxima</Typography>
                  <Controller
                    control={control}
                    className="mb-3"
                    name="area.areaMaxima"
                    rules={{
                      required: 'El campo es requerido',
                    }}
                    render={({ field }) => (
                      <Select
                        classNamePrefix="select"
                        isSearchable={true}
                        placeholder="Seleccionar Área Máxima"
                        options={areasOrganizacionales}
                        getOptionLabel={(option) => option.nombre}
                        getOptionValue={(option) => option.id}
                        onChange={(e) => field.onChange(e.id)}
                        value={areasOrganizacionales.find((x) => x.id === field.value)}
                      />
                    )}
                  />

                  <p className="text-danger mb-0">{errors?.area?.areaMaxima?.message}</p>
                </div>

                <div className="form-group mt-3">
                  <Typography sx={style.text}>Cargo Supervisa</Typography>
                  <Controller
                    control={control}
                    name="area.encargadoId"
                    rules={{
                      required: 'El campo es requerido',
                    }}
                    render={({ field }) => (
                      <Select
                        classNamePrefix="select"
                        isSearchable={true}
                        placeholder="Seleccionar Cargo"
                        options={cargos}
                        getOptionLabel={(option) => option.titulo}
                        getOptionValue={(option) => option.id}
                        onChange={(e) => field.onChange(e.id)}
                        value={cargos.find((x) => x.id === field.value)}
                      />
                    )}
                  />

                  <p className="text-danger mb-0">{errors?.area?.encargadoId?.message}</p>
                </div>

                <div className="d-flex justify-content-center mt-3">
                  <button type="submit" className="btn btn-primary-mem me-3">
                    {' '}
                    <SaveIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} /> Guardar
                  </button>
                  <button type="button" className="btn btn-danger " onClick={handleClose}>
                    {' '}
                    <DoNotDisturbAltIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} /> Cancelar
                  </button>
                </div>
              </div>
            </div>
          </form>
        ) : (
          <Loading open={isLoading} />
        )}
      </Box>
    </Modal>
  );
};

export default AreaOrganizacionalNuevo;
